// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hospitals-section .el-dialog {\n  width: 60%;\n}\n@media screen and (min-width: 1600px) {\n.hospitals-section .el-dialog {\n    width: 50%;\n}\n}\n@media screen and (min-width: 1600px) {\n.hospitals-section .select-fields-list {\n    grid-template-columns: 1fr 1fr 1fr !important;\n}\n}", ""]);
// Exports
module.exports = exports;
